import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import Theme from "context/themeContext";
import { BrowserRouter } from "react-router-dom";

import "./global.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Theme>
        <App />
      </Theme>
    </BrowserRouter>
  </React.StrictMode>
);
